import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import XLiteService from '@/services/XLiteService.js'
const debug = require('debug')('xlite-web-client:router')
const ArticleTable = () => import('@/components/ArticleTable.vue')
const BarcodeScanner = () => import('@/components/BarcodeScanner.vue')
const Search = () => import('@/components/Search.vue')
const Analytics = () => import('@/components/Analytics.vue')
const MediaGallery = () => import('@/components/MediaGallery.vue')

//const UserDetails = () => import('./views/UserDetails')

const routes = []
const predefinedPaths = []
const applicationPaths = []

const predefinedRoutes = [
    {
        path: '/login',
        name: 'login',
        component: () => import('@/pages/Login.vue'),
        meta: {
            requireAuth: false
        }
    },
    {
        path: '/profile',
        name: 'profile',
        component: () => import('@/components/Profile.vue'),
        meta: {
            breadcrumb: [{ parent: 'Moduli', label: 'Profilo' }],
            requireAuth: false
        }
    },
    {
        path: '/error',
        name: 'error',
        component: () => import('@/pages/Error.vue'),
        meta: {
            requireAuth: false
        }
    },
    {
        path: '/notfound',
        name: 'notfound',
        component: () => import('@/pages/NotFound.vue'),
        meta: {
            requireAuth: false
        }
    },
    {
        path: '/access',
        name: 'access',
        component: () => import('@/pages/Access.vue'),
        meta: {
            requireAuth: false
        }
    },
    {
        path: '/500',
        name: '500',
        component: () => import('@/pages/Error.vue'),
        props: { showLogo: false, reloadButton: false },
        meta: {
            breadcrumb: [{ label: '' }]
        }
    },
    {
        path: '/403',
        name: '403',
        component: () => import('@/pages/Access.vue'),
        props: { showLogo: false },
        meta: {
            breadcrumb: [{ label: '' }]
        }
    },
    {
        path: '/404',
        name: '404',
        component: () => import('@/pages/NotFound.vue'),
        props: { showLogo: false },
        meta: {
            breadcrumb: [{ label: '' }]
        }
    }
]
predefinedRoutes.forEach(route => {
    routes.push(route)
    predefinedPaths.push(route.path)
});

const applicationRoutes = [
    {
        path: '/',
        name: 'dashboard',
        exact: true,
        component: () => import('@/components/Dashboard.vue'),
        meta: {
            breadcrumb: [{ parent: 'Dashboard', label: 'Dashboard' }],
            requireAuth: true
        },
    },
    {
        path: '/articletable',
        name: 'ArticleTable',
        component: ArticleTable,
        props: { isLazy: true },
        meta: {
            breadcrumb: [{ parent: 'Moduli', label: 'Articoli' }],
            requireAuth: true
        },
    },
    {
        path: '/barcode',
        name: 'Barcode',
        component: BarcodeScanner,
        meta: {
            breadcrumb: [{ parent: 'Moduli', label: 'Barcode' }],
            requireAuth: true
        },
    },
    {
        path: '/search',
        name: 'Search',
        component: Search,
        meta: {
            breadcrumb: [{ parent: 'Moduli', label: 'Ricerca' }],
            requireAuth: true
        }
    },
    {
        path: '/analytics',
        name: 'Analytics',
        component: Analytics,
        meta: {
            breadcrumb: [{ parent: 'Moduli', label: 'Analytics' }],
            requireAuth: true
        }
    },
    {
        path: '/operatoranalytics',
        name: 'Analytics Operatore',
        component: Analytics,
        props: { operatorLimited: true },
        meta: {
            breadcrumb: [{ parent: 'Moduli', label: 'Analytics Operatore' }],
            requireAuth: true
        }
    },
    {
        path: '/mediagallery',
        name: 'Media Gallery',
        component: MediaGallery,
        meta: {
            breadcrumb: [{ parent: 'Moduli', label: 'Media Gallery' }],
            requireAuth: true
        }
    },
    {
        path: '/:pathMatch(.*)',
        component: () => import('@/pages/NotFound.vue')
    }
]
if(process.env.VUE_APP_ARGV.split(',').includes('--dev')){
    /*
    applicationRoutes.push(
        
    )
    */
}
applicationRoutes.forEach(route => {
    routes.push(route)
    applicationPaths.push(route.path)
});

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior () {
        return { left: 0, top: 0 };
    }
});


router.beforeEach(async (to, from) => {
    store.dispatch('enableGlobalLoading');
    debug(`From ${from.path} to ${to.path}`)
    const toPath = to.path
    const queryParams = to.query

    if (!applicationPaths.includes(toPath) && !predefinedPaths.includes(toPath)) {
        to.query.lt = undefined
        if(store.getters.a){
            return { path: '/404' }
        } else {
            return { path: '/notfound' }
        }
    }

    try {
        const authenticationType = await XLiteService.operatorInfo();
        const data = authenticationType.data;
        //const e = authenticationType.headers['x-auth-e'];
        const li = data.li;
        const oldAuthStatus = store.getters.a;
        await store.dispatch('setLi', { li, e: 'router' }); // will also set .a correctly
        if (li !== 'lasting') {
            // Operator is in a temp session or not in session at all
            if (to.name != 'login' && to.meta.requireAuth) {
                debug('to:', to)
                store.dispatch('setRequestedRouterDestination', to)
                if (oldAuthStatus) {
                    await store.dispatch('logout');
                    await store.dispatch('setSto', true);
                    return { name: 'login' };
                } else {
                    return { name: 'login' };
                }
            }
        } else {
            // Operator is in a valid lasting session
            await store.dispatch('setOperator', data.operatorData);
            if (to.name == 'login') {
                return { name: 'dashboard' }
            } else {
                const dbPaths = await store.dispatch('setDbPaths')
                debug('dbPaths', dbPaths)
                if ((dbPaths && !dbPaths.includes(toPath)) && !predefinedPaths.includes(toPath)) {
                    debug('Not allowed')
                    return { path: '/403' }
                } else {
                    if((!dbPaths || !dbPaths.length) && to.name != '500'){
                        return { path: '/500' }
                    } else if(queryParams.lt){
                        try{
                            await XLiteService.tokenMatch(queryParams.lt)
                        } catch {
                            alert(`Già autenticato come ${store.getters.operator}`)
                        }
                        queryParams.lt = undefined
                        return { path: toPath, query: queryParams }
                    }
                }
            }
        }
    } catch (err) {
        // TODO: handle possible backend errors setting fields properly
        if(to.name != '500'){
            return { path: '/500' }
        }
        debug(err);
    } finally {
        store.dispatch('disableGlobalLoading');
    }
});


export default router;